import { useEffect, useState } from "react";
import { Copy, Twitter, MessageCircle, Github, Send, CheckCircle2 } from "lucide-react";
import { getCoinInfo } from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [info, setInfo] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    getCoinInfo().then(setInfo).catch(() => {});
  }, []);

  const copy = async () => {
    if (!info?.contract_address) return;
    try {
      await navigator.clipboard.writeText(info.contract_address);
      setCopied(true);
      toast.success("Contract address copied");
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      toast.error("Could not copy");
    }
  };

  return (
    <footer className="relative border-t border-white/10 bg-[#040405]" data-testid="site-footer">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#39FF14]/40 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="font-display text-2xl font-black tracking-widest">ARENACOIN</div>
          <p className="mt-3 text-white/55 font-mono text-sm max-w-sm">
            The native token of Arena Platform — a series of PvP multiplayer betting tournaments. No
            house. No edge. Just the pool.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {[Twitter, Send, MessageCircle, Github].map((Icon, i) => (
              <a
                key={i}
                href="#"
                onClick={(e) => e.preventDefault()}
                className="w-10 h-10 grid place-items-center border border-white/15 hover:border-[#39FF14] hover:text-[#39FF14] transition-colors"
                data-testid={`social-link-${i}`}
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50 mb-3">Resources</div>
          <ul className="space-y-2 font-mono text-sm">
            <li><a href="#about" className="text-white/70 hover:text-[#39FF14]">Platform</a></li>
            <li><a href="#tokenomics" className="text-white/70 hover:text-[#39FF14]">Tokenomics</a></li>
            <li><a href="#roadmap" className="text-white/70 hover:text-[#39FF14]">Roadmap</a></li>
            <li><a href="#" onClick={(e) => e.preventDefault()} className="text-white/70 hover:text-[#39FF14]">Whitepaper</a></li>
            <li><a href="#" onClick={(e) => e.preventDefault()} className="text-white/70 hover:text-[#39FF14]">Audit Report</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50 mb-3">Contract Address</div>
          <button
            onClick={copy}
            className="w-full text-left glass p-3 flex items-center justify-between gap-3 group"
            data-testid="contract-address-copy"
          >
            <span className="font-mono text-xs text-white/70 truncate">
              {info?.contract_address || "0x000…000"}
            </span>
            {copied ? <CheckCircle2 className="w-4 h-4 text-[#39FF14]" /> : <Copy className="w-4 h-4 text-white/50 group-hover:text-[#39FF14]" />}
          </button>
          <p className="mt-3 font-mono text-[10px] text-white/40 leading-relaxed">
            Note: Contract address publishes after audit completion. Always verify the address from
            the official site before transacting.
          </p>
        </div>
      </div>

      <div className="border-t border-white/10 py-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-2 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
          <span>© {new Date().getFullYear()} Arena Platform · All rights reserved</span>
          <span>ARC · BEP-20 on BNB Smart Chain · Audit-ready</span>
        </div>
      </div>
    </footer>
  );
}
